
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq0bZCfY993TvMioXOqKt0hGOqbPBqRJ3_f1sSMvqvhPAMeta } from "/codebuild/output/src447213354/src/src/pages/faq.vue?macro=true";
import { default as menu4fx_45RFQc90tB3Oc7c7qej3eopGdsVKGE_PXbx06q13MMeta } from "/codebuild/output/src447213354/src/src/pages/menu.vue?macro=true";
import { default as indexyWDKIf3xEOKfZcTiluW_f9lcygXAybK_lcedHJhj2ZkMeta } from "/codebuild/output/src447213354/src/src/pages/index.vue?macro=true";
import { default as contactHx4QXuZPLBFbqi5cs92U_g8YfutEcq0cvON2G2TPATYMeta } from "/codebuild/output/src447213354/src/src/pages/contact.vue?macro=true";
import { default as tutorialHFowLb6iJd9m0_45hTT13d5n3fXY9kMVFU8WggnBWki9EMeta } from "/codebuild/output/src447213354/src/src/pages/tutorial.vue?macro=true";
import { default as agreementg7EM_iqQOoCBy6U5QkRKvfdyJOk4Dup7ApJrUxiImLIMeta } from "/codebuild/output/src447213354/src/src/pages/agreement.vue?macro=true";
import { default as about_45passVjoGfJjRBrpT_xLc4wFFYupKmYJPcGGt1Wp12IXhCEoMeta } from "/codebuild/output/src447213354/src/src/pages/about-pass.vue?macro=true";
import { default as indexUhlI50kv_45AjbhGUNMYXYybKmVk1Q14JqenSUs_45bC8sYMeta } from "/codebuild/output/src447213354/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93ye12ifjFAQ3DSCkl5jQMVSOqU3ZsPGA2uWhVxC8H3n0Meta } from "/codebuild/output/src447213354/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance_45JJok6eOO6Q7Lu_Hsh_DZFYLupu0i9hIlQeJvGWGP7wMeta } from "/codebuild/output/src447213354/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93p1pMNJ1hZG3V5NzWwrOKvg_45Foq0F_eF5mab89yGMJ64Meta } from "/codebuild/output/src447213354/src/src/pages/notice/[id].vue?macro=true";
import { default as index5MbuM_45YvonynGHEFEcCRWNjMMv4WVaAp7iyzq_454_f_oMeta } from "/codebuild/output/src447213354/src/src/pages/coupon/index.vue?macro=true";
import { default as indexpgsJ1wN_jyY7YYK9cMBzBcjs5ZQ_loZv1Lq6_45PKGEzUMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/index.vue?macro=true";
import { default as index7H9ftROFfpOvmoG3ZLD4ZoU2q_6arQLEcVjFyvvlyy4Meta } from "/codebuild/output/src447213354/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93BhVJYCWQeO8bkoXYwETF9n6AOTyNcwnjD8v4lWjGf54Meta } from "/codebuild/output/src447213354/src/src/pages/parking/[id].vue?macro=true";
import { default as indexZFR9XKyZFg9WEH0FiLrEMIXC9NyX2FtBj8RGhyQWpl8Meta } from "/codebuild/output/src447213354/src/src/pages/history/index.vue?macro=true";
import { default as indexEMx8zLcJkpQ6hgioSqygKRARPSbW83f18vmly_51fxwMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/index.vue?macro=true";
import { default as indexVQr4Fr0Xg_xsCuooG_4599woiZe_45sHymWaHEzooSqacTwMeta } from "/codebuild/output/src447213354/src/src/pages/sign-in/index.vue?macro=true";
import { default as index61MQ60NMmSj85nFKefeNNlrcxz4c5Qhpd3ogBE8xIXYMeta } from "/codebuild/output/src447213354/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviVwTarajyo6QSP6PorOi_45058anKppe8j1KbXm5Qtg2KgMeta } from "/codebuild/output/src447213354/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editqu_45OlKrdSjFy6kIW8_cOyg6118kUOyJIGqlS0N8GkhMMeta } from "/codebuild/output/src447213354/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementw3W58J9YDIKdAe9u_Mli4LAkNiJoZQwVNXrL56vfoMMMeta } from "/codebuild/output/src447213354/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexxBZ4dZuSUzC5YoWc2yAdXmkenyi2RUJWdGARzl5J3wcMeta } from "/codebuild/output/src447213354/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dKOCueT5dnvEZipkqL__45Mh9V2Lkf5L_jTceOz1wY9UuIMeta } from "/codebuild/output/src447213354/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm6AgkYZL53jD8nlsYcRYIl8kpcRfJMYcs6zrW7Wzy5iQMeta } from "/codebuild/output/src447213354/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexVNorDBuQX_S_G6zdytULRluCXzmwjNDdlAnmZF_458F_gMeta } from "/codebuild/output/src447213354/src/src/pages/card/create/index.vue?macro=true";
import { default as indexc43yJMEYn3g4o2HxZalKsCoG27X92y2OtM_45k2Lhjg7YMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmEJgvyYz9_45WKkLhH7Wv_ksWWAtppE6x7pmYxueZ_A8GwMeta } from "/codebuild/output/src447213354/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmr1MX7sPOAZmxS4ybNdCgspGA0_rebqDAz3fyXqpkkdUMeta } from "/codebuild/output/src447213354/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete9MTmVgfvLT4ZMn0qlYxYmO6GvThsw8NJxMlEHGe2V5QMeta } from "/codebuild/output/src447213354/src/src/pages/membership/complete.vue?macro=true";
import { default as registerDbPKhPy9_45_45ghKYrPTEv0m1ynBpUqZ8qCvfZbWPANxfEMeta } from "/codebuild/output/src447213354/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93jmQo0kBx9g9NlbYoYMNwO6S94LwFqjW6DDNR5DDxQmEMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmCL0_45pXUN36M4faRLX3OeRTATA7bAkFcUuBwBomm0BxMMeta } from "/codebuild/output/src447213354/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93XaVGR2qke_wXk633icuRJcJ8r4wev1P9nzYwThfarFMMeta } from "/codebuild/output/src447213354/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexNNHbZEgrM1t8CAjDaxehXvZst8P2nQ5CBrPf2HUzd1oMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codemr71jzWsHg0HHudJLK2IfEIu6DTbBLSn1QvpOys8IP4Meta } from "/codebuild/output/src447213354/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeA_45t1f_45BmF3TS_DugN9crFc7QLPqjDEhy0LYQPW1V2VYMeta } from "/codebuild/output/src447213354/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completedHxK5KPzp4MjV1Qw06XNTQ39K50FIOKoEQrLLHHYSe4Meta } from "/codebuild/output/src447213354/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registeryN9rwneLxcBJEHj6YvMdFG5b8EZjVgkr6zFhYCKssn8Meta } from "/codebuild/output/src447213354/src/src/pages/contact-form/register.vue?macro=true";
import { default as completefzuBy534exDSaia61kQqzsKJmmN1GA9mpTd3KAdIPmoMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexjxBKT1FNcoRsGeASN5LEm8bKJgDNuVwpzi2NOz6eWaQMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmDoDFxx2TGrtqeG5VZNNZDK5eV3BzLel3ceJG4F7yX9UMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completerCAJQZ5NC17N7mA1We1ahZKeQK0YB7hDzGEzl5z96goMeta } from "/codebuild/output/src447213354/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexyNpzx2zjADWjXqDdi4_BA7AfirabTiE9LKn9u9Bly30Meta } from "/codebuild/output/src447213354/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93NWz7N9G2mR27GyG1V2dm2Vm7wGyuENnvIjDzUHOs0NQMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeDpsNS3FsVQlhgL70CPM3G209bCiU96fFCH46USZ_XOMMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasLxK43vphNn3NPrS4poCEpNjShK_CfnlzCsrxaMmg0mIMeta } from "/codebuild/output/src447213354/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample7HoMgEqEqSwjJTx1LQyoelu3rP2V_N_MgGSV0Bc_45mU0Meta } from "/codebuild/output/src447213354/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailJdjbNGGpjWsqTEpn9Qwjksh3norGBuYem5Sbu2RGj70Meta } from "/codebuild/output/src447213354/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmtKHeSWihyh9_iwiJs5SDq_aftXyVCi2pLKZEMH152EUMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentLMXH3px9c8uK6LZQSoJtFx3rGVFg4atTyGIwx6rksJcMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmhYULiB9ZEc7oWdCppNR21I7nQO3MemmaGd6XPFw_2cEMeta } from "/codebuild/output/src447213354/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateyc79rTcDPHkjE_xhS4WwtfmQ6xrHpPr83jMusHvnGukMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completenKJUktVypI0XKLRiVQPJ8BcNogYyaUMssmedLuFz6lsMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeNXM0x7bg0y2aeiGwo7KPaaxbnt7uvXOGdb1LaMGKjTUMeta } from "/codebuild/output/src447213354/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password9JK6m1_45g4SYmXyJrFfV4tjyV9kem0IOHODrOXjUPg78Meta } from "/codebuild/output/src447213354/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasijq6axB9etWbJAy9r8U_3hnZJjhnFdP2GrDpWVEIBtcMeta } from "/codebuild/output/src447213354/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registera2Ch5mifnlZfVN8LAv6nzRKLY7FgGOojx304jhebQAMMeta } from "/codebuild/output/src447213354/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codemCq7QE2OtA_T1xDUmX9GGu4sgHmsLSi3RIAJWDNvG8EMeta } from "/codebuild/output/src447213354/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index2BhXxpJ0SMiEu_458ga5oemlUEwFuKJ_455cUYgQmLNuOKgMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexN2QooqhowZRUswI0rm1VFN3UjKe4ghss2LjEFRdreeQMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index_et2XdWjsxibaxGxXM6fee3ze2dqqCElxwFz477u6KsMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexYdAX17e9KIZleI5hi0XjQgnJ4Q_45WIsa8IwqMO3cSBAcMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateswUBF0bss35ayVziVyVrDhONfa7bHO3Fy_GxuLfRhBsMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeu4d92BblLQbyfxWw3JhZ7DTal_45O7uPUg6tLWvoZflbQMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmYxCBJ_45FraJbjuY_45G4RTO0HREU0F8IBC6szoZF4pN_hwMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index_FSftWZIBPRlfGH06XkQrCq4i66tCmDv1aLVo53ks2AMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete6IxDwBYE_452SXYqfiKQ3OTbkJKk0qxebrrPrjLCRu5rAMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update_45BrjpBPBuqGlagJDZXzrdSfqIydc9LrhvNv5uX0oO6MMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexJ19cV6OMMY6F8wuj3IQRSyHm52_j5yGgGmh_45oacvVwoMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexbnmExB92UfpEUkpJWATbzX4vE4kYumy1VxdETFvMFBEMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeJNNnEnJKhXEJwq5dGXZpu0Ex3c5R0S1R1_9txkGW6tAMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexVctfVj1G9TW5WCjfpLt4gx2r6oDXurZocBwHALXqxjcMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeuPMPOxt2R6xYT3agc4sKPwHVGTcvBbBYlZWUVAMRv34Meta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexbmrrw6wRx1b0XZBT_45xKuesOPSI28txdiqevtEFjR1xsMeta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexwvU1ocUBzOPDVxf9pVv1rboL2OI_m8VEbzxMOAfPYX8Meta } from "/codebuild/output/src447213354/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexMkWG_QZdt5ofH08DVu8CFjtRb5CQqVv5KE_45Ucw8wHnAMeta } from "/codebuild/output/src447213354/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateNOfuspMfJ3s7RC7C5HxsCyhRltznSwrxkn7QfC3dxV0Meta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmDSBcpFdqlRnwxfvfh17EsUSr1zohofGcr3dpHzw6Ly8Meta } from "/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src447213354/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu4fx_45RFQc90tB3Oc7c7qej3eopGdsVKGE_PXbx06q13MMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexyWDKIf3xEOKfZcTiluW_f9lcygXAybK_lcedHJhj2ZkMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src447213354/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src447213354/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src447213354/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src447213354/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src447213354/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index5MbuM_45YvonynGHEFEcCRWNjMMv4WVaAp7iyzq_454_f_oMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src447213354/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src447213354/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexZFR9XKyZFg9WEH0FiLrEMIXC9NyX2FtBj8RGhyQWpl8Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexVQr4Fr0Xg_xsCuooG_4599woiZe_45sHymWaHEzooSqacTwMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index61MQ60NMmSj85nFKefeNNlrcxz4c5Qhpd3ogBE8xIXYMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src447213354/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src447213354/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexVNorDBuQX_S_G6zdytULRluCXzmwjNDdlAnmZF_458F_gMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmEJgvyYz9_45WKkLhH7Wv_ksWWAtppE6x7pmYxueZ_A8GwMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmr1MX7sPOAZmxS4ybNdCgspGA0_rebqDAz3fyXqpkkdUMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete9MTmVgfvLT4ZMn0qlYxYmO6GvThsw8NJxMlEHGe2V5QMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerDbPKhPy9_45_45ghKYrPTEv0m1ynBpUqZ8qCvfZbWPANxfEMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmCL0_45pXUN36M4faRLX3OeRTATA7bAkFcUuBwBomm0BxMMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codemr71jzWsHg0HHudJLK2IfEIu6DTbBLSn1QvpOys8IP4Meta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeA_45t1f_45BmF3TS_DugN9crFc7QLPqjDEhy0LYQPW1V2VYMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completedHxK5KPzp4MjV1Qw06XNTQ39K50FIOKoEQrLLHHYSe4Meta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registeryN9rwneLxcBJEHj6YvMdFG5b8EZjVgkr6zFhYCKssn8Meta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmDoDFxx2TGrtqeG5VZNNZDK5eV3BzLel3ceJG4F7yX9UMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completerCAJQZ5NC17N7mA1We1ahZKeQK0YB7hDzGEzl5z96goMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexyNpzx2zjADWjXqDdi4_BA7AfirabTiE9LKn9u9Bly30Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeDpsNS3FsVQlhgL70CPM3G209bCiU96fFCH46USZ_XOMMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample7HoMgEqEqSwjJTx1LQyoelu3rP2V_N_MgGSV0Bc_45mU0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailJdjbNGGpjWsqTEpn9Qwjksh3norGBuYem5Sbu2RGj70Meta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmtKHeSWihyh9_iwiJs5SDq_aftXyVCi2pLKZEMH152EUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentLMXH3px9c8uK6LZQSoJtFx3rGVFg4atTyGIwx6rksJcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmhYULiB9ZEc7oWdCppNR21I7nQO3MemmaGd6XPFw_2cEMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completenKJUktVypI0XKLRiVQPJ8BcNogYyaUMssmedLuFz6lsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeNXM0x7bg0y2aeiGwo7KPaaxbnt7uvXOGdb1LaMGKjTUMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password9JK6m1_45g4SYmXyJrFfV4tjyV9kem0IOHODrOXjUPg78Meta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src447213354/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registera2Ch5mifnlZfVN8LAv6nzRKLY7FgGOojx304jhebQAMMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codemCq7QE2OtA_T1xDUmX9GGu4sgHmsLSi3RIAJWDNvG8EMeta || {},
    component: () => import("/codebuild/output/src447213354/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src447213354/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src447213354/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]